export enum CancellationType {
  Airline = "AIRLINE",
  Priority = "PRIORITY",
  Standard = "STANDARD",
  Voucher = "VOUCHER",
}
